import * as R from 'ramda'

export default function (value, defaultValue) {
    return R.defaultTo(defaultValue)(value)
}
